import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReassignmentSelectInputPlaceholder = () => /*#__PURE__*/_jsxs(Flex, {
  alignItems: "center",
  "data-test-id": "reassignment-select-placeholder",
  inlineSize: "150px",
  blockSize: "42px",
  padding: "250",
  paddingInlineStart: "0",
  children: [/*#__PURE__*/_jsx(SkeletonCircle, {
    size: 24,
    marginInlineEnd: "100"
  }), /*#__PURE__*/_jsxs(Flex, {
    blockSize: "100%",
    flexDirection: "column",
    inlineSize: "100%",
    justifyContent: "space-around",
    children: [/*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "50%",
      blockSize: "0.75em"
    }), /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "100%",
      blockSize: "0.75em"
    })]
  })]
});
ReassignmentSelectInputPlaceholder.displayName = 'ReassignmentSelectInputPlaceholder';
export default ReassignmentSelectInputPlaceholder;